import { createContext, useContext } from "react";

export const UserProfileContext = createContext(null);

export const useUserProfile = () => useContext(UserProfileContext) || {};
